import { Link } from "react-router-dom";
import { STATUS_LABELS } from "../lib/brand";

export const inputCls = "w-full rounded-md border border-input bg-card px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring disabled:opacity-60";
export const btn = "inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50";
export const btnPrimary = `${btn} bg-navy text-white hover:bg-navy-700 dark:bg-pulse dark:hover:bg-pulse-dark`;
export const btnAccent = `${btn} bg-pulse text-white hover:bg-pulse-dark`;
export const btnGhost = `${btn} border border-border bg-card hover:bg-muted`;

export const PageTitle = ({ title, sub, actions, testId = "admin-page-title" }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-testid={testId}>{title}</h1>
      {sub && <p className="mt-1 text-sm text-muted-foreground">{sub}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const Panel = ({ title, children, className = "", testId }) => (
  <section className={`rounded-lg border border-border bg-card p-5 ${className}`} data-testid={testId}>
    {title && <h2 className="mb-4 text-sm font-bold uppercase tracking-[0.12em] text-muted-foreground">{title}</h2>}
    {children}
  </section>
);

export const Field = ({ label, htmlFor, children, hint }) => (
  <div>
    <label htmlFor={htmlFor} className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</label>
    {children}
    {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
  </div>
);

const TONES = {
  draft: "bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200",
  in_review: "bg-blue-100 text-blue-900 dark:bg-blue-900/50 dark:text-blue-100",
  fact_check: "bg-violet-100 text-violet-900 dark:bg-violet-900/50 dark:text-violet-100",
  approved: "bg-amber-100 text-amber-900 dark:bg-amber-900/50 dark:text-amber-100",
  published: "bg-emerald-100 text-emerald-900 dark:bg-emerald-900/50 dark:text-emerald-100",
  archived: "bg-zinc-200 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-block whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-bold ${TONES[status] || TONES.draft}`} data-testid={`status-badge-${status}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const Empty = ({ children, testId = "admin-empty" }) => (
  <p className="rounded-md border border-dashed border-border p-6 text-center text-sm text-muted-foreground" data-testid={testId}>{children}</p>
);

export const Forbidden = () => (
  <div className="py-20 text-center" data-testid="admin-forbidden">
    <h1 className="font-display text-3xl font-semibold">Nemate pristup</h1>
    <p className="mt-2 text-sm text-muted-foreground">Vaša uloga nema ovlaštenje za ovaj modul.</p>
    <Link to="/admin" className={`${btnGhost} mt-6`}>Nazad na kontrolnu ploču</Link>
  </div>
);
